import {FileType, IFile} from "./types";
import {IdObjectsWithId} from "../../utils";
import {IFileData} from "./filedata/types";
import {sassBase, sassHorizontal, sassInterstitialLandscape, sassMain, sassVariables} from "../banner/editor/sass";
import {contentHtmlData, indexHtmlData} from "../banner/editor/template";

export const dummyFiles: IdObjectsWithId<IFile> = {
    byId: {
        'root': {
            id: 'root',
            type: FileType.FOLDER,
            name: 'root',
            path: '/',
            created: {},
            updated: {},
            createdBy: 'lei',
            updatedBy: 'lei',
            children: [
                'sass',
                'html'
            ]
        },
        'sass': {
            id: 'sass',
            type: FileType.FOLDER,
            name: 'sass',
            path: '/sass',
            created: {},
            updated: {},
            createdBy: 'lei',
            updatedBy: 'lei',
            parentPath: '/',
            parentId: 'root',
            children: [
                'main.scss',
                'base.scss'
            ]
        },
        'main.scss': {
            id: 'main.scss',
            type: FileType.FILE,
            name: 'main.scss',
            path: '/sass/main.scss',
            fileDataId: 'main.scss_data',
            created: {},
            updated: {},
            createdBy: 'lei',
            updatedBy: 'lei',
            parentPath: '/sass',
            parentId: 'sass',
            children: [
            ]
        },
        'base.scss': {
            id: 'base.scss',
            type: FileType.FILE,
            name: 'base.scss',
            path: '/sass/base.scss',
            fileDataId: 'base.scss_data',
            created: {},
            updated: {},
            createdBy: 'lei',
            updatedBy: 'lei',
            parentPath: '/sass',
            parentId: 'sass',
            children: [
            ]
        },
        'variables.scss': {
            id: 'variables.scss',
            type: FileType.FILE,
            name: 'variables.scss',
            path: '/sass/variables.scss',
            fileDataId: 'variables.scss_data',
            created: {},
            updated: {},
            createdBy: 'lei',
            updatedBy: 'lei',
            parentPath: '/sass',
            parentId: 'sass',
            children: [
            ]
        },
        'horizontal.scss': {
            id: 'horizontal.scss',
            type: FileType.FILE,
            name: 'horizontal.scss',
            path: '/sass/horizontal.scss',
            fileDataId: 'horizontal.scss_data',
            created: {},
            updated: {},
            createdBy: 'lei',
            updatedBy: 'lei',
            parentPath: '/sass',
            parentId: 'sass',
            children: [
            ]
        },
        'interstitialLandscape.scss': {
            id: 'interstitialLandscape.scss',
            type: FileType.FILE,
            name: 'interstitialLandscape.scss',
            path: '/sass/interstitialLandscape.scss',
            fileDataId: 'interstitialLandscape.scss_data',
            created: {},
            updated: {},
            createdBy: 'lei',
            updatedBy: 'lei',
            parentPath: '/sass',
            parentId: 'sass',
            children: [
            ]
        },
        'html': {
            id: 'html',
            type: FileType.FOLDER,
            name: 'html',
            path: '/html',
            created: {},
            updated: {},
            createdBy: 'lei',
            updatedBy: 'lei',
            parentPath: '/',
            parentId: 'root',
            children: [
                'index.html',
                'content.html'
            ]
        },
        'index.html': {
            id: 'index.html',
            type: FileType.FILE,
            name: 'index.html',
            path: '/html/index.html',
            fileDataId: 'index.html_data',
            created: {},
            updated: {},
            createdBy: 'lei',
            updatedBy: 'lei',
            parentPath: '/html',
            parentId: 'html',
            children: [
            ]
        },
        'content.html': {
            id: 'content.html',
            type: FileType.FILE,
            name: 'content.html',
            path: '/html/content.html',
            fileDataId: 'content.html_data',
            created: {},
            updated: {},
            createdBy: 'lei',
            updatedBy: 'lei',
            parentPath: '/html',
            parentId: 'html',
            children: [
            ]
        }
    },
}
export const dummyFileData: IdObjectsWithId<IFileData> = {
    byId: {
        'main.scss_data': {
            id: 'main.scss_data',
            data: sassMain,
            created: {},
            updated: {},
            createdBy: '',
            updatedBy: '',
        },
        'base.scss_data': {
            id: 'base.scss_data',
            data: sassBase,
            created: {},
            updated: {},
            createdBy: '',
            updatedBy: '',
        },
        'variables.scss_data': {
            id: 'variables.scss_data',
            data: sassVariables,
            created: {},
            updated: {},
            createdBy: '',
            updatedBy: '',
        },
        'horizontal.scss_data': {
            id: 'horizontal.scss_data',
            data: sassHorizontal,
            created: {},
            updated: {},
            createdBy: '',
            updatedBy: '',
        },
        'interstitialLandscape.scss_data': {
            id: 'interstitialLandscape.scss_data',
            data: sassInterstitialLandscape,
            created: {},
            updated: {},
            createdBy: '',
            updatedBy: '',
        },
        'index.html_data': {
            id: 'index.html_data',
            data: indexHtmlData,
            created: {},
            updated: {},
            createdBy: '',
            updatedBy: '',
        },
        'content.html_data': {
            id: 'content.html_data',
            data: contentHtmlData,
            created: {},
            updated: {},
            createdBy: '',
            updatedBy: '',
        }
    }
}

export const defaultFileData: IFileData = {
    id: 'new',
    data: '',
    created: {},
    updated: {},
    createdBy: 'lei',
    updatedBy: 'lei',
}